import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { ServerResponseService } from '@app/shared/services/server-response/server-response.service';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { Persist } from '@app/analytics/actions/data-layer';

@Component({
  selector: 'not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  statusCode: number;
  errorImgPath = '/edito_v2/18231801190619-summer-sales-bags-3000x900.jpg';

  constructor(
    private route: ActivatedRoute,
    private responseService: ServerResponseService,
    private store: Store<IAppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(
      params => {
        if (isPlatformServer(this.platformId)) {
          // Defaults to 404 if no statusCode provided.
          this.statusCode = params['statusCode'] || 404;
          this.responseService.setStatusOnly(this.statusCode);
        }
      },
      () => {
        // silent catch nothing to do
      }
    );
    this.store.dispatch(
      new Persist({
        env_template: 'default_noside',
        pageUrl: this.route.snapshot.queryParamMap.get('url') || 'unknow'
      })
    );
  }
}
